import {
  Typography,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import notFoundImage from '../assets/not-found.png';
import { authed } from '../features/login/loginSlice';

export default function NotFound() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isLogged = useSelector(authed);

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Container>
      <Grid
        container
        padding={'1.875rem'}
        justifyContent="center"
        direction={desktop ? 'row' : 'column'}
      >
        <Grid
          item
          md={12}
          sx={{
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <img
              src={notFoundImage}
              style={{
                width: '25%',
                maxHeight: 'auto',
              }}
            />
            <Typography variant="h1" my={2}>
              Parece que esta página no existe!
            </Typography>
            <Box
              sx={{ cursor: 'pointer', textAlign: 'center' }}
              onClick={
                isLogged ? () => navigate('/') : () => navigate('/login')
              }
            >
              <Typography variant="body2">
                Ir a la pantalla principal
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
